import * as React from 'react';
import * as styles from './translate-button.module.scss';
import { createPortal } from 'react-dom';
import CloseIcon from '../icons/close-icon';
import classNames from '../../utilities/class-names'
import safariTranslateIconUrl from './safari-translate-icon.png';

const TranslateButton = () => {
    const popupRef = React.useRef(null);
    const buttonRef = React.useRef(null);
    const [open, setOpen] = React.useState(false);

    React.useEffect(() => {
        if (!open) {
            return;
        }

        const abortController = new AbortController();

        document.body.addEventListener('click', (e) => {
            if (popupRef.current && !popupRef.current.contains(e.target) && !buttonRef.current.contains(e.target)) {
                setOpen(false);
            }
        }, { signal: abortController.signal });

        return () => {
            abortController.abort();
        };
    }, [open]);


    return (
        <>
            {open && createPortal(<>
                <div ref={popupRef} className={styles.translateInstructions}>
                    <div className={styles.translateInstructionsTitle}>
                        <div>Browser Translation</div>
                        <button type="button" className={styles.translateInstructionsCloseButton} onClick={() => setOpen(false)}>
                            <CloseIcon></CloseIcon>
                        </button>
                    </div>
                    <div className={styles.translateInstructionsBody}>
                        <p><strong>Chrome:</strong> Right-click the page and choose <em>Translate to your language</em>, or use the Translate icon in the address bar.</p>
                        <p><strong>Edge:</strong> Click the Translate icon in the address bar, or open the menu and choose <em>Translate</em>.</p>
                        <p><strong>Firefox:</strong> Open the menu, choose <em>Translate page</em>, then pick your language.</p>
                        <p><strong>Safari:</strong> Click the <img src={safariTranslateIconUrl} alt='Safari Translate' className={styles.safariTranslateIcon} /> button in the address bar and select <em>Translate to...</em>.</p>
                    </div>
                </div>
            </>,
                document.body
            )}
            <button ref={buttonRef} className={classNames(styles.translateButton, open && styles.active)} type="button" onClick={() => setOpen(!open)}>
                <div className="d-none d-sm-block">English</div>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2M8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2M8 14C8 14 10.5 12 10.5 8C10.5 4 8 2 8 2M8 14C8 14 5.5 12 5.5 8C5.5 4 8 2 8 2M2.34115 6H13.6586M2.34115 10H13.6586" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </button>
        </>
    )
}

export default TranslateButton;